<template>
  <div class="index">
    <!-- <Top /> -->
    <router-view class="index-body" />
    <!-- <Bottom /> -->
  </div>
</template>
<script lang="ts" setup>
// import Top from "@/views/pageModel/index/top/TopIndex.vue";
// import Bottom from "@/views/pageModel/index/bottom/BottomIndex.vue";
import { ref, provide, readonly, defineComponent } from "vue";
const only = ref("readonly!");
// defineComponent({ Top });
provide("message", "hellow!");
provide("only", readonly(only));
</script>
<style lang="less" scoped>
.index {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-flow: column;
  .index-body {
    flex: 1;
  }
}
</style>
